import hasPerksGOLocations from "@irati/deals/helpers/deals/hasPerksGOLocations";
import isPerksGORetailDeal from "@irati/deals/helpers/deals/isPerksGORetailDeal";
var isPerksGO = function (deal) {
    return (isPerksGORetailDeal(deal) || hasPerksGOLocations(deal));
};
export default isPerksGO;
